import { render, staticRenderFns } from "./MaterialDealer.vue?vue&type=template&id=37d0f769&"
import script from "./MaterialDealer.vue?vue&type=script&lang=js&"
export * from "./MaterialDealer.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDealer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports